import React, { useState, useEffect } from 'react';

import { useContext } from 'components/Members/Programs/Views/Show/Context';

import ProgressBar from 'components/Widgets/ProgressBar';

import routes from 'app/routes';

import { useNavigate } from 'react-router-dom';

export default function BuildProgram() {
  const [progress, setProgress] = useState(0);

  const { dispatch, actions, state } = useContext();

  const navigate = useNavigate();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setProgress((prev) => {
        const next = prev + 1;
        return next <= 100 ? next : 100;
      });
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    actions.prepareNewAiProgram(dispatch, 6);
  }, []);

  useEffect(() => {
    if (state.program) {
      const nextUrl = routes.members.programs.new_ai.orderTopics(state.program.id);
      navigate(nextUrl, { replace: true });
    }
  }, [state.program]);

  return (
    <>

      <div className="onboarding-content my-5">
        <div style={{ maxWidth: '500px', margin: '0 auto' }}>
          <ProgressBar now={progress} />
        </div>
      </div>
      <div className="content onboarding-content">
        <div className="row">
          <div className="col-lg order-lg-last">
            <div className="bg-photo bg-members-onboarding-welcome-photo" />
          </div>
          <div className="col-lg order-lg-first">
            <div className="pt-4 p-sm-4 pe-lg-0 h-100 d-flex flex-column">
              <h1>Finalizing Your Custom Program</h1>
              <p className="mt-3">
                Hear from our members:
              </p>
              <blockquote className="blockquote">
                “LeggUP has empowered me to become a better version of myself at home and work.
                I&apos;m so grateful for this growth!”
              </blockquote>
              <figcaption className="blockquote-footer">
                Sara
              </figcaption>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
